<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td></td>
          <td class="listview__title items">NAME</td>
          <td class="listview__title placement">REMARK</td>
          <td class="listview__title dailyvisitor">COLLECTION</td>
          <td class="listview__title price">ADDED TO PAGE</td>
          <td class="listview__title price">VISIBILITY</td>
        </tr>
      </thead>
      <draggable v-if="!isLoading && !isEmpty" v-model="listItems" @start="onStart" @end="onEnd" :element="'tbody'">
        <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
          <td>
            <i class="adx-ic_arrow_drag"></i>
          </td>
          <td class="items">
            <div class="item">
              <div class="stack">
                <span class="title">{{item.title}}</span>
                <span class="location">
                  {{item.layout_display}}
                </span>
              </div>
            </div>
          </td>
          <td class="placement none"><span>{{item.remarks}}</span></td>
          <td class="visitor none"><span>{{item.item_count}} item</span></td>
          <td class="visitor none"><span>{{collectionList(item.page_list)}}</span></td>
          <td class="visibilty-action">
            <div class="visibilty-action__wrapper">
              <div class="visibility">
                <adx-selectdropdown :itemId="item.id" @selected="selected" :value.sync="item.status" :label="`Visibility`" :options="dropdown" />
              </div>
              <div class="menuExpansion">
                <menu-expansion :itemID="item.id" @selected="selectedExpansion" :lists="menuList" />
              </div>
            </div>
          </td>
        </tr>
      </draggable>
    </table>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !isLoading" />
    </div>
    <div class="listview__loadingWrapper">
      <adx-loading v-if="isLoading" />
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import MenuExpansion from '@/components/MenuExpansion'
import draggable from 'vuedraggable'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-collection-list-item',
  components: {
    'adx-selectdropdown': SelectDropdown,
    'menu-expansion': MenuExpansion,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    draggable
  },
  props: {
    items: {
      required: false
    },
    menuList: {
      required: false
    },
    pageId: {
      required: false,
    },
    isLoading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
      dropdown: [
        {
          label: 'Public',
          value: 'Public'
        },
        {
          label: 'Private',
          value: 'Private'
        }
      ],
      hover: [],
      listScheduleByDevice: [],
      listItems: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selected(item) {
      (async () => {
        const data = {
          id: item.id,
          visibility: item.item.value == 'Public' ? true : false
        }
        const response = await api.patch(apiV2.collectionGroupVisiblity(item.id), data, { needToken: true })
        this.$notify({
          group: 'saved',
          title: 'Update Visibility Success',
          text: `${response.data.title} has been successfully changed to ${response.data.status}`,
          type: 'success'
        })
      })();
    },
    collectionList(item) {
      if (item.length > 0) {
        return item.join(', ')
      } else {
        return 'None'
      }
    },
    onStart(evt, asd) {
    },
    onEnd(evt) {
      (async () => {
        const id = this.items[evt.oldIndex].id
        const data = {
          group_id: id,
          page_id: parseInt(this.pageId),
          order: evt.newIndex + 1
        }
        const response = await api.patch(apiV2.collectionGroupOrder, data, { needToken: true })
        this.$emit('orderChanged')
      })();

    },
    listClick() {

    },
    selectedExpansion(item) {
      switch(item.value) {
        case 'delete':
          (async () => {
            const response = await api.destroy(apiV2.collectionGroupDetail(item.item_id), { needToken: true })
            if (response.status === 204) {
              this.$notify({
                group: 'saved',
                title: 'Delete Success',
                text: `group has been successfully deleted`,
                type: 'success'
              });
              this.$emit('orderChanged')
            }
          })();
          break;
        case 'duplicate':
          (async () => {
            const response = await api.patch(apiV2.collectionGroupDuplicate(item.item_id), {}, { needToken: true })
            if (response.status === 201) {
              this.$notify({
                group: 'saved',
                title: 'Duplicate Success',
                text: `group has been successfully duplicated`,
                type: 'success'
              });
              this.$emit('orderChanged')
            } else {
              this.$notify({
                group: 'saved',
                title: 'Duplicate Error',
                text: response.data.message,
                type: 'danger'
              });
            }
          })();
          break;
        case 'addpage':
          (async () => {
            const body = {
              groups_id: [item.item_id]
            }
            const response = await api.post(apiV2.collectionGroupAddToPage(item.items.id), body, { needToken: true })
            if (response.status === 201) {
              this.$notify({
                group: 'saved',
                title: 'Add to Group Success',
                text: `group has been successfully added to Group`,
                type: 'success'
              });
              this.$emit('orderChanged')
            } else {
              this.$notify({
                group: 'saved',
                title: 'Add Error',
                text: response.data.message,
                type: 'danger'
              });
            }
          })();
          break;
        case 'remove':
          (async () => {
            const data = {
              page_id: parseInt(this.pageId),
            }
            const response = await api.patch(apiV2.collectionGroupRemovePage(item.item_id), data, { needToken: true })

            this.$emit('orderChanged')
            this.$emit('dataChanged')
          })();
          break;
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>